import React from 'react'
import TransactionTable from './TransactionTable'

export const Transaction = () => {
  return (
    <>
    <h1 className='font-bold mb-5 text-xl'>Transaction Details</h1>
    <TransactionTable/>
    </>
  )
}
